import { useToastStore } from '~/components/ToastManager/useToasts';

const useClipboard = () => {
    const { addToast } = useToastStore();
    const write = (text: string): Promise<void> =>
        navigator.clipboard.writeText(text).then(() =>
            addToast({
                type: 'success',
                title: 'Text kopiert',
                description: 'Der Inhalt wurde in die Zwischenablage gespeichert.'
            })
        );

    const read = (): Promise<string> => navigator.clipboard.readText();

    return { write, read };
};

export default useClipboard;
